import {Component, OnInit, ViewChild} from '@angular/core';
import {PharmacyService} from 'src/app/services/pharmacy.service';
import {ActivatedRoute, Route, Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import { PharmacyUserAddress} from '../lab-detail/lab-detail.component';
import {GooglePlaceDirective} from 'ngx-google-places-autocomplete';
import { ToastrService } from 'ngx-toastr';
import {Maps} from '../../../assets/mapModel'
import { AuthService } from 'src/app/services/auth.service';
//directives:[Calendar]
declare var google: any
@Component({
  selector: 'app-pharmacy-detail',
  templateUrl: './pharmacy-detail.component.html',
  styleUrls: ['./pharmacy-detail.component.css']
})
export class PharmacyDetailComponent implements OnInit {
  pharmacyDetail: any = {}
  availability: any = []
  pharmacyUploadShow: PharmacyShow[] = []
  pharmacyUploadSend = []
  isImage: boolean = false
  isLoggedIn = localStorage.getItem('token') ? true : false
  addressFields = <PharmacyUserAddress>{}
  minDateValue:Date=new Date()
  valueDate:Date=null
  valueTime:Date= null
  realAddress: boolean = false
  imageUrlArray:any=[]
  slideConfigCustomers = {
    infinite: true,
    speed: 300,
    arrows: false,
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  };
  @ViewChild("placesRef") placesRef: GooglePlaceDirective
  options = {
    types: [],
    componentRestrictions: {country: 'in'}
  }
  isDisable=true

  
  // map keys
  map: any = {};
  marker: any = {};
  mapKeys = Maps;

  isBloodbank = false;

  constructor(public pharmacySvc: PharmacyService, 
    public activatedRoute: ActivatedRoute, 
    private toaster: ToastrService,
     public datepipe: DatePipe,
     public router:Router,
     private auth:AuthService) {
  }

  ngOnInit() {
  
    if (this.router.url.includes('blood')) {
      this.isBloodbank = true;
    }
    let date = new Date();
    let latest_date = this.datepipe.transform(date, 'dd-MM-yyyy');
    if (this.activatedRoute.snapshot.params.id)
      this.getPharmacyDetail(this.activatedRoute.snapshot.params.id, latest_date)
    this.getCurrentLocation()
  }

  getCurrentLocation() {
    // if(!this.isLoggedIn){
    //   this.bookObject['name'] = ''
    //   this.bookObject['phoneNo'] = ''
    // }
    // this.bookObject['name'] = '';
  
    this.auth.getLocation().then(location => {
      if(!location.nolocation){
        this.addressFields.lat = Number(localStorage.getItem('lat')) 
             this.addressFields.lng = Number(localStorage.getItem('lng')) 
       
         
      }
      else{
      this.addressFields.lng = 76.7794 
             this.addressFields.lat = 30.7333
      }
      this.initializeMap()
   
      

     
   
    
    })

    //this.bookObject['address'] = localStorage.getItem('currentaddress');
  }

  initializeMap() {
    var latlng = new google.maps.LatLng(this.addressFields.lat, this.addressFields.lng);
    var myOptions = {
      zoom: this.mapKeys.zoomModal,
      center: latlng,
     // styles: this.mapKeys.style,
      streetViewControl: false,
      disableDefaultUI: false,
      mapTypeControl: false,
      gestureHandling: "greedy"
    };
    this.map = new google.maps.Map(document.getElementById("mapLocation"), myOptions);
    this.map.setCenter(latlng);
    this.getLocation();
   // const self = this;
    this.map.addListener('center_changed', function () {
      this.getLocation();
    });

  }
  getLocation() {
    //const self = this;
    this.addressFields.lat = this.addressFields.lat
    this.addressFields.lng = this.addressFields.lng
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({
      'latLng': this.map.getCenter()
    }, (results,status) => {
      if (status == google.maps.GeocoderStatus.OK) {
        if (!!results && results.length) {
          console.log(results)
          console.log('results[0].formatted_address', results[0].formatted_address)
          this.addressFields.address = results[0].formatted_address;
          localStorage.setItem('currentaddress',results[0].formatted_address)

          results[0].address_components.map((addr:any)=>{
 
     
            if(addr.types[0]=='locality' && addr.types[1]=='political'){
              localStorage.setItem('currentcity',addr.long_name) 
              
              
            }
           
        
        })

          
        }
      }
    });
  }
  getPharmacyDetail(pharmacyId: string, date) {

    this.pharmacySvc.getpharmacyDetail(pharmacyId, date).subscribe(res => {
      console.log(res)
      this.pharmacyDetail = res["data"][0]
      this.availabilityTiming(this.pharmacyDetail.timings)
    }, error => {
      console.log(error)

    })

  }

  availabilityTiming(timing) {
    let lengthTimings = timing.length

   
  for(let i=0;i<lengthTimings;i++){
   
    if(!timing[i].startTime || !timing[i].endTime){

    }
    else if(this.tConvert(timing[i].startTime)==this.tConvert(timing[i].endTime)){
      this.availability.push({timing:timing[i].showDay!=null ? timing[i].showDay+' | ' + this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime) :  this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime),error:true})
    }
    else{
   
    this.availability.push({timing:timing[i].showDay!=null ? timing[i].showDay+' | ' + this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime) :  this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime),error:false})
    }
  }

  }
  counter(i: number) {
    return new Array(i);
}

  tConvert(time) {
    // Check correct time format and split into components

    let time1 = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    let time2: any

    if (time1.length > 1) { // If time format correct
      time2 = time1.slice(1);  // Remove full string match value
      time2[5] = +time2[0] < 12 ? ' am' : ' pm'; // Set AM/PM
      time2[0] = +time2[0] % 12 || 12; // Adjust hours
    } else {

    }
    //console.log(time2)
    return time2.join('') // return adjusted time or original string
  }

  fileChanged(event) {
    //this.pharmacyUploadShow.profilePicture = "https://i.imgur.com/VWTO1In.gif"
    this.pharmacySvc.fileUpload(event.target.files[0]).subscribe(res => {
        console.log(res)
        this.pharmacyUploadShow.push({ size: '12', image: res['data']['thumb']})
        this.pharmacyUploadSend.push(res['data']['thumb'])

        this.isImage = true

      },
      error => {
        alert('There was some error')
        console.log(error)
      })


  }

  removeUpload(index) {

    this.pharmacyUploadShow.splice(index, 1)
    this.pharmacyUploadSend.splice(index, 1)
    if (this.pharmacyUploadSend.length == 0) {
      this.isImage = false
    }
  }

  bookPharmacy() {
    
  //   let year = this.valueDate.getFullYear()
  //   let month = this.valueDate.getMonth()+ 1
  //   let day = this.valueDate.getDate()
  //  let date = year + '/' + month + '/' + day
  //  let hours = this.valueTime.getHours()
  //  let min = this.valueTime.getMinutes()
  //  let sec = this.valueTime.getSeconds()
  //  let time = hours + ':' + min + ':' + sec
  //  let timeDate = date + ' ' + time

  //  let timestamp  = Math.round(new Date(timeDate).getTime())
  //  console.log(timestamp)
  //   this.addressFields.dateTime = timestamp

    this.bookPharmacyConfirm()


    
  }
  gotoUserOrders(){
    localStorage.setItem('tab','pharmacy')
    this.router.navigate(['/user-orders'])
  }
  checkDistanceStatus(){

    this.pharmacySvc.pharmecyDistance(this.addressFields,this.activatedRoute.snapshot.params.id).subscribe(res=>{
      if(res["data"]["distance"]<=20){
        this.getTimingStatus()
      }
      else{
        this.isDisable = true
        this.toaster.error('Pharmecy Too Far from your location...', 'Error',{
          timeOut: 2000
        });
      }
      },error=>{
        this.isDisable = true
        this.toaster.error(error.error.message, 'Error',{
          timeOut: 2000
        });
      })
  }
  changed(){
    setTimeout( () => {
    this.getTimingStatus()

  }, 1000 );
  }
  bookPharmacyConfirm(){
    this.pharmacySvc.pharmacyBooking(this.activatedRoute.snapshot.params.id, this.pharmacyUploadSend, this.addressFields).subscribe(res => {
      console.log(res)
      document.getElementById('address_pharmacy').click()
      document.getElementById('order_confirm').click()

      console.log('ammmm herererreere')

      // this.router.navigate(['/']);

      // this.route.

    }, error => {
      this.toaster.error(error.error.message, 'Error',{
        timeOut: 2000
      });
    })
  }
  getTimingStatus(){
    if(this.valueTime==null || this.valueDate==null){
      this.isDisable=true
      return false
    }
    let year = this.valueDate.getFullYear()
    let month = this.valueDate.getMonth()+ 1
    let day = this.valueDate.getDate()
   let date = year + '/' + month + '/' + day
console.log(this.valueTime)

  let hours = this.valueTime.getHours()
   let min = this.valueTime.getMinutes()
   let sec = this.valueTime.getSeconds()
   let time = hours + ':' + min + ':' + sec
   let timeDate = date + ' ' + time

   let timestamp  = Math.round(new Date(timeDate).getTime())
   let current_time = new Date().getTime()
   if(current_time>timestamp)
   {
     this.isDisable=true
     this.toaster.error("Booking Time already passed...", 'Error',{
       timeOut: 2000
     });
     return false
   }

   // this.addressFields.dateTime = timestamp


    this.pharmacySvc.getTimingStatus(this.activatedRoute.snapshot.params.id,this.addressFields).subscribe(res=>{
      if(res["data"]["timingStatus"]){
        this.isDisable=false
        this.checkDistanceStatus()
        
      }
      else{
        this.isDisable=true
        this.toaster.error("Booking Time not available..Please select another time", 'Error',{
          timeOut: 2000
        });
      }
    },error=>{
      this.isDisable=true
      this.toaster.error(error.error.message, 'Error',{
        timeOut: 2000
      });
    })
    return false
    
  }

  loginFirst() {
    this.valueDate = null
    this.valueTime = null
   //this.addressFields.dateTime = null
    this.isLoggedIn = localStorage.getItem('token') ? true : false
    if (this.isLoggedIn){
      this.addressFields.address=localStorage.getItem('currentaddress') ? localStorage.getItem('currentaddress') : JSON.parse(localStorage.getItem('logindata'))['address']
      this.addressFields.city=JSON.parse(localStorage.getItem('logindata'))['city'] ? JSON.parse(localStorage.getItem('logindata'))['city'].toLowerCase() : localStorage.getItem('currentcity').toLowerCase()
      this.addressFields.lat=Number(localStorage.getItem('lat'))
      this.addressFields.lng=Number(localStorage.getItem('lng'))
      document.getElementById('address_pharmacy').click()
    }
    else {
      localStorage.setItem('pharmacyBookingData', JSON.stringify(this.pharmacyUploadSend))
      localStorage.setItem('pharmacyIdBook', this.activatedRoute.snapshot.params.id)
      document.getElementById('logintoggle_user').click()
    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

  handleAddressChange(event) {
    this.realAddress = true
    var latlng = new google.maps.LatLng(event.geometry.location.lat(), event.geometry.location.lng());
    this.map.setCenter(latlng);
    this.addressFields.address = event.formatted_address
    this.addressFields.lat = event.geometry.location.lat()
    this.addressFields.lng = event.geometry.location.lng()
    let flag = 0
    event.address_components.map((addr: any) => {
      if (addr.types[0] == 'locality' && addr.types[1] == 'political') {
        this.addressFields.city = addr.long_name
        flag = 1

      }

    })
    if (flag == 0)
      this.addressFields.city = event.formatted_address.split(',')[0]

      this.checkDistanceStatus()
  }

  removePharmacyData() {
  }

  checkAddress() {
    console.log('sdfsd')
    this.realAddress = false
  }
  showImagePopup(image){
    this.imageUrlArray=[]
    this.imageUrlArray.push(image)
    document.getElementById('orderImagesCLick').click()
  }
  showImages(){
    this.imageUrlArray=this.pharmacyDetail.images
    //console.log(this.imageUrlArray)
    document.getElementById('orderImagesCLick').click()
  }
}

export interface PharmacyShow {
  
  size: string,
  image: string,
  name?: string
}
